<template>
    <div class="series-detail">
        <div class="banner">
            <Carousel :slides="banners"></Carousel>
        </div>

        <div class="module series">
            <Series v-for="(item, index) in series.list" :key="index" :series="item"></Series>
        </div>

        <ProductList class="product-list" :product-list="recommendedProducts"></ProductList>
    </div>
</template>

<script>
    import Carousel from '../components/common/Carousel'
    import Series from '../components/container/series/Series'
    import ProductList from '../components/common/ProductList'
    import Chunk from 'loadsh/chunk'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'seriesDetail',
        components: {
            Carousel,
            Series,
            ProductList,
        },
        computed: {
            ...mapState('seriesDetail', {
                series: ({series}) => {
                    let list = series.data.map((item) => {
                        let subSeries = item.subcategories.map((sub, subIndex) => {
                            let res = [[]]

                            sub.products = Chunk(sub.products, 2)

                            let row = []

                            const lang = localStorage.getItem('lang') || 'cn'

                            let secondTitle = '', secondDesc = ''
                            if (lang === 'cn') {
                                secondTitle = item.en_name
                                secondDesc = sub.en_name
                            } else {
                                secondTitle = item.cn_name
                                secondDesc = sub.cn_name
                            }

                            if (subIndex % 2 === 0) {
                                row.push({
                                    isBanner: true,
                                    banner: {
                                        imgSrc: sub.figure_src,
                                        title: item.name,
                                        desc: sub.name,
                                        secondTitle,
                                        secondDesc,
                                    },
                                    products: [],
                                },{
                                    isBanner: false,
                                    banner: {
                                        imgSrc: ''
                                    },
                                    products: [],
                                })
                            } else {
                                row.push({
                                    isBanner: false,
                                    banner: {
                                        imgSrc: ''
                                    },
                                    products: [],
                                },{
                                    isBanner: true,
                                    banner: {
                                        imgSrc: sub.figure_src,
                                        title: item.name,
                                        desc: sub.name,
                                    },
                                    products: [],
                                })
                            }

                            let len = sub.products.length

                            sub.products.forEach((productChunk, productChunkIndex) => {

                                if (productChunkIndex === 0) {
                                    if (subIndex % 2 === 0) {
                                        row[1].products = productChunk.map((product) => {
                                            return {
                                                parentPath: '/product/',
                                                tags: product.tags,
                                                slug: product.slug,
                                                imgSrc: product.cover_picture,
                                                title: item.name,
                                                label: sub.name,
                                                desc: [
                                                    {
                                                        text: product.product_name,
                                                    },
                                                    {
                                                        text: product.price,
                                                    }
                                                ]
                                            }
                                        })
                                    } else {
                                        row[0].products = productChunk.map((product) => {
                                            return {
                                                parentPath: '/product/',
                                                tags: product.tags,
                                                slug: product.slug,
                                                imgSrc: product.cover_picture,
                                                title: item.name,
                                                label: sub.name,
                                                desc: [
                                                    {
                                                        text: product.product_name,
                                                    },
                                                    {
                                                        text: product.price,
                                                    }
                                                ]
                                            }
                                        })
                                    }

                                    res[0].push([...row])
                                    row = []
                                }

                                if (productChunkIndex > 0) {
                                    row.push({
                                        isBanner: false,
                                        banner: {
                                            imgSrc: ''
                                        },
                                        products: productChunk.map((product) => {
                                            return {
                                                parentPath: '/product/',
                                                tags: product.tags,
                                                slug: product.slug,
                                                imgSrc: product.cover_picture,
                                                title: item.name,
                                                label: sub.name,
                                                desc: [
                                                    {
                                                        text: product.product_name,
                                                    },
                                                    {
                                                        text: product.price,
                                                    }
                                                ]
                                            }
                                        }),
                                    })

                                    if (productChunkIndex % 2 === 0 || productChunkIndex === len - 1) {
                                        res[0].push([...row])
                                        row = []
                                    }
                                }
                            })

                            return res
                        })

                        return {
                            caption: item.title,
                            desc: item.description,
                            slug: item.slug,
                            subSeries: subSeries,
                        }
                    })

                    return {
                        list: list
                    }
                },
                banners: ({banners}) => {
                    return banners.map((banner, index) => {
                        return {
                            isPic: banner.type === 'pic',
                            isVideo: banner.type === 'video',
                            video: {
                                ref: 'allSeries' + index,
                                videoSrc: banner.src_file,
                                loop: true,
                                muted: true,
                                autoplay: true,
                            },
                            imgSrc: banner.src_file,
                            width: 1680,
                            height: 600,
                        }
                    })
                },

                recommendedProducts: ({recommendedProducts}) => {

                    let items = recommendedProducts.map(product => {
                        return {
                            parentPath: '/product/',
                            tags: product.tags,
                            slug: product.slug,
                            imgSrc: product.cover_picture,
                            title: product.category_name,
                            label: product.subcategory_name,
                            desc: [
                                {
                                    text: product.product_name,
                                },
                                {
                                    text: product.price,
                                }
                            ]
                        }
                    })

                    const lang = localStorage.getItem('lang') || 'cn'

                    return {
                        title: lang === 'cn' ? '为您推荐以下饰品' : 'SELECTED PRODUCTS FOR YOU',
                        items,
                    }
                }

            })
        },
        methods: {
            ...mapActions('seriesDetail', ['getPageInfo'])
        },
        created() {
            this.getPageInfo(this.$route.params.id)
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .series-container {
        /deep/ .title {
            padding-top: 100px;
        }
    }
</style>
